import React from 'react';
import PropTypes from 'prop-types';
import { dragNDropConstants } from '../Globals/constants';
import EmployeeDragPreview from './DragPreviews/employeeDragPreview';
import ActivityDragPreview from '../Project/ActivityOverview/activityDragPreview';
import WorkplaceDragPreview from '../ShortTermProjects/Kanban/workplaceDragPreview';
import StickyNoteDragPreview from '../ShortTermProjects/Kanban/stickyNoteDragPreview';
import { DragLayer } from 'react-dnd';
var createReactClass = require('create-react-class');

var layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100000,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
};

function getItemStyles(props) {
  const { initialOffset, currentOffset } = props;
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none'
    };
  }
  let { x, y } = currentOffset;
  if (props.snapToGrid) {
    x -= initialOffset.x;
    y -= initialOffset.y;
    x += initialOffset.x;
    y += initialOffset.y;
  }
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform: transform,
    WebkitTransform: transform
  };
}

function collect(monitor) {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  };
}

var CustomDragLayer = createReactClass({
  renderItem: function (type, item) {
    switch (type) {
      case dragNDropConstants.EMPLOYEE:
        return (
          <EmployeeDragPreview {...item} />
        );
      case dragNDropConstants.ACTIVITY:
        return (
          <ActivityDragPreview {...item} />
        );
      case dragNDropConstants.WORKPLACE:
        return <WorkplaceDragPreview {...item} />
      case dragNDropConstants.STICKYNOTE:
        return <StickyNoteDragPreview {...item} />
      default:
        return (
          <div>Im dragging something</div>
        )
    }
  },

  render: function () {
    var item = this.props.item;
    var itemType = this.props.itemType;
    var isDragging = this.props.isDragging;
    if (!isDragging) {
      return null;
    }

    return (
      <div style={layerStyles}>
        <div style={getItemStyles(this.props)}>
          {this.renderItem(itemType, item)}
        </div>
      </div>
    );
  }
});

CustomDragLayer.propTypes = {
  item: PropTypes.object,
  itemType: PropTypes.string,
  currentOffset: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }),
  isDragging: PropTypes.bool.isRequired
};

export default DragLayer(collect)(CustomDragLayer);


// WEBPACK FOOTER //
// ./src/App/Util/customDragPreview.jsx